"use client";

import { usePostHog } from "posthog-js/react";

const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.chickytutor";

interface GooglePlayBadgeLinkProps {
  placement: "homepage_header" | "homepage_mobile_modal";
}

export function GooglePlayBadgeLink({ placement }: GooglePlayBadgeLinkProps) {
  const posthog = usePostHog();

  return (
    <a
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Get ChickyTutor on Google Play"
      onClick={() =>
        posthog?.capture("google_play_badge_clicked", {
          placement,
          app_package: "com.chickytutor",
        })
      }
      className="inline-flex self-center rounded-md p-2.5 transition-transform hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-300 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0f0f14] active:translate-y-px motion-reduce:transform-none"
    >
      <img
        src="/images/google-play-badge-en.svg"
        alt="Get it on Google Play"
        width={135}
        height={40}
        className="h-10 w-auto"
      />
    </a>
  );
}
